import React from "react";

export function ScrollTop() {
  return (
    <div id="kt_scrolltop" className="scrolltop">
      <i className="ki ki-bold-arrow-back icon-sm up-arrow-scroller" />
    </div>
  );
}
